import { extend } from 'lodash';
import * as moment from 'moment';
import {SegmentTypes} from '../constants';
import {ISegmentType} from '../interfaces/segment-type.interface';

export class CtxSegment {
    ID: number;
    Name: string;
    UUID: string;
    Source: string;
    CreatedAt: string;
    CreatedBy: number;
    UpdatedAt: string;
    DeletedAt: string;
    ToBeDeletedAt: string;
    Notes: string;
    UrlCount: number;
    EndDate: Date = moment().add(1, 'month').toDate();
    Frequency: number;
    IsActive: boolean;
    Type: number = 1;
    SegmentType: ISegmentType;
    IsDepreciated: boolean = false;
    prompt: string;
    similarity_threshold: string;

    public static fromJSON(params: any = {}): CtxSegment {
        const segment = extend(new CtxSegment(), params);
        segment.SegmentType = Object.values(SegmentTypes).find((type) => type.value === segment.Type);
        return segment;
    }

    /**
     * Number of days remaining until a Scheduled for Removal segment is
     * deleted, derived from ToBeDeletedAt. Returns null when no removal
     * date is set. Never returns a negative value; a date in the past
     * resolves to 0 (deletion is due).
     * @param segment Object
     * @returns number of days remaining, or null
     */
    public static daysUntilDeletion(segment: CtxSegment): number | null {
        if (!segment.ToBeDeletedAt) {
            return null;
        }
        const deletionDate = moment(segment.ToBeDeletedAt);
        if (!deletionDate.isValid()) {
            return null;
        }
        const days = deletionDate.startOf('day').diff(moment().startOf('day'), 'days');
        return Math.max(days, 0);
    }
}
